<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-2">
      {{ $t("af:preliminary.first_step.title") }}
    </p>

    <p class="has-text-grey-icon mb-4">
      {{ $t("af:preliminary.first_step.subtitle") }}
    </p>

    <!--
    <p class="label mt-5 mb-6">
      {{ $t("af:preliminary.first_step.amount.title") }}
    </p>
    -->

    <validation-observer ref="observer">
      <AmountSlider v-model="amount" />
      <TermSlider class="mt-5" v-model="duration" />
    </validation-observer>

    <div class="offer-change-info mt-4">
      <b-icon
        icon-pack="fa"
        icon="info-circle"
        size="is-medium"
        type="is-blue"
        class="mr-2"
      ></b-icon>
      <span class="has-text-grey-icon">{{
        $t("af:preliminary.first_step.footer")
      }}</span>
    </div>

    <div v-if="activePurchase" class="mb-5">
      <p class="has-text-weight-bold is-size-5 mb-2 mt-6">
        {{ $t("af:preliminary.first_step.purchase.title") }}
      </p>

      <div class="is-flex mt-4">
        <span class="has-text-grey-icon">
          {{ $t("af:preliminary.first_step.purchase.total_amount.label") }}
        </span>

        <span class="has-text-weight-bold ml-auto">
          {{ activePurchase.totalAmount | monify }} Ft
        </span>
      </div>

      <div class="is-flex mt-2">
        <span class="has-text-grey-icon">
          {{ $t("af:preliminary.first_step.purchase.down_payment.label") }}
        </span>

        <span class="has-text-weight-bold ml-auto">
          {{ downPayment | monify }} Ft
        </span>
      </div>

      <div class="is-flex mt-2">
        <span class="has-text-grey-icon">
          {{ $t("af:preliminary.first_step.purchase.extra_amount.label") }}
        </span>

        <span class="has-text-weight-bold ml-auto">
          {{ extraAmount | monify }} Ft
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { FIELD_MASK } from "@/utils/const";
import { editLandingParam } from "../../utils/landingParamUtil";
import merchandiseMixin from "../../mixins/merchandiseMixin";
import AmountSlider from "@/components/AmountSlider.vue";
import { watch } from "vue";

export default {
  name: "PreliminaryAmountAndTerm",
  mixins: [merchandiseMixin],
  components: {
    AmountSlider,
    TermSlider: () => import("@/components/TermSlider.vue"),
  },
  props: {
    filterSettings: {
      type: Object,
      required: true,
    },
    activePurchase: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      amount: 0,
      duration: 0,
      downPayment: 0,
      extraAmount: 0,
      FIELD_MASK,
    };
  },
  async created() {
    await this.prefillValue("amount");
    await this.prefillValue("duration");

    if (this.activePurchase) {
      await this.prefillValue("downPayment");
      await this.prefillValue("extraAmount");
    }

    this.$watch("amount", this.amountWatcher);
    this.$watch("duration", this.durationWatcher);
  },
  methods: {
    prefillValue(questionId) {
      this[questionId] = this.getAmountFromStore(questionId);
    },
    getAmountFromStore(questionId) {
      return this.$store.getters["preliminaryAssessment/answer"](questionId);
    },
    storeData(questionId) {
      this.$store.dispatch("preliminaryAssessment/addData", {
        question: questionId,
        answer: this[questionId],
      });
    },
    amountWatcher() {
      this.storeData("amount");

      if (this.activePurchase) {
        this.downPayment = this.calculateDownPayment(this.amount);
        this.extraAmount = this.calculateExtraAmount(this.amount);
        this.storeData("downPayment");
        this.storeData("extraAmount");
      }
    },
    durationWatcher() {
      this.storeData("duration");
    },
  },
};
</script>

<style scoped lang="scss">
.offer-change-info {
  display: flex;
  align-items: center;
}

.loan-min-max {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.mbh {
  .offer-change-info {
    border-radius: 24px;
    padding: 16px 24px 16px 24px;
    background: #e6e9f0;
    display: flex;
    align-items: center;

    .has-text-grey-icon {
      color: #203667 !important;
    }
  }
}
</style>
